import script from "./InitialStep.vue?vue&type=script&setup=true&lang=js"
export * from "./InitialStep.vue?vue&type=script&setup=true&lang=js"

import "./InitialStep.vue?vue&type=style&index=0&id=f41602a2&lang=sass&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f41602a2"]])

export default __exports__